import { useCallback } from "react";
import { AssembleTypography } from "src/components/AssembleTypography";
import { StyledBlockButton } from "../StyledBlockButton/StyledBlockButton";

const HEADER_1 = "header-one";

export type H1BlockProps = {
  editorState: Draft.EditorState;
  onClick: (headline: string) => void;
};

export const H1Block = (props: H1BlockProps): JSX.Element => {
  const { editorState, onClick } = props;

  const startKey = editorState.getSelection().getStartKey();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(startKey)
    .getType();
  const active = blockType === HEADER_1;

  const onClickHeadline = useCallback(() => {
    onClick(HEADER_1);
  }, [onClick]);

  return (
    <StyledBlockButton active={active} onClick={onClickHeadline}>
      <AssembleTypography style={{ fontSize: "22px", fontWeight: "bold" }}>
        H1
      </AssembleTypography>
    </StyledBlockButton>
  );
};
